/*@flow*/
import useContextState from './useContextState';

export default function useHasLocation(): boolean {
  const { focusedLatlon } = useContextState();
  return Boolean(focusedLatlon);
}
